import { RunState } from "types/generated";
import { AccessResult } from "utils/access";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import StopRunButton from "components/Run/elements/StopRunButton";
import KillRunButton from "components/Run/elements/KillRunButton";
import RunPhaseLogs from "components/Run/elements/RunPhaseLogs";
import { useVisibilityToggle } from "components/Run/hooks/useVisibilityToggle";

import { RunHistoryEntryType } from "../../types";

type ApplyingEntryProps = {
  timestamp: number;
  until: number | null;
  stateVersion: number | null;
  hasLogs: boolean;
  openLogsByDefault: boolean;
  showTerminateButtons: boolean;
  beforeHooks: string[] | undefined;
  afterHooks: string[] | undefined;
  runId: string;
  stackId: string;
  isModuleRun: boolean;
  canStop: AccessResult;
  canKill: AccessResult;
  runQueryToRefetch: string;
};

const ApplyingEntry = ({
  timestamp,
  until,
  stateVersion,
  hasLogs,
  openLogsByDefault,
  showTerminateButtons,
  beforeHooks,
  afterHooks,
  runId,
  stackId,
  isModuleRun,
  canStop,
  canKill,
  runQueryToRefetch,
}: ApplyingEntryProps) => {
  const [showLogs, toggleLogs] = useVisibilityToggle(openLogsByDefault, hasLogs);

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Applying}
      timestamp={timestamp}
      until={until}
      isLoading={!until}
      onClick={toggleLogs}
      isOpen={showLogs}
    >
      {showLogs && (
        <RunPhaseLogs
          beforeHooks={beforeHooks}
          afterHooks={afterHooks}
          state={RunState.Applying}
          stateVersion={stateVersion}
          until={until}
          runId={runId}
          stackId={stackId}
          isModuleRun={isModuleRun}
        >
          {showTerminateButtons && (
            <>
              <StopRunButton
                canStop={canStop}
                runId={runId}
                stackId={stackId}
                runQueryToRefetch={runQueryToRefetch}
              />
              <KillRunButton
                canKill={canKill}
                runId={runId}
                stackId={stackId}
                runQueryToRefetch={runQueryToRefetch}
              />
            </>
          )}
        </RunPhaseLogs>
      )}
    </HistoryEntryWrapper>
  );
};

export default ApplyingEntry;
